import { ITableColumn, TableColumnTypeEnum, WidthType } from "./tableColumn.interface";

export const ViolationRulesTableColumns: ITableColumn[] = [
    {
        labelPath: "policyPage.policy.violationRules.tableColumns.ruleName",
        propertyKey: "ruleName",
        colType: TableColumnTypeEnum.InternalNavigation,
        width: 30,
        widthType: WidthType.Percentage,
        tooltipDynamicText: "ruleDescription",
        isSortable: false,
        sortKey: "ruleName",
        internalNavigationQuery: "violationsEndpointQuery",
        internalNavigationRoute: "violationsEndpointRoute",
    },
    {
        labelPath: "policyPage.policy.violationRules.tableColumns.ruleId",
        propertyKey: "ruleId",
        colType: TableColumnTypeEnum.CopyableText,
        width: 12,
        widthType: WidthType.Percentage,
        isSortable: false,
        sortKey: "ruleId",
    },
    {
        labelPath: "policyPage.policy.violationRules.tableColumns.ruleTags",
        propertyKey: "tags",
        colType: TableColumnTypeEnum.Tag,
        width: 20,
        widthType: WidthType.Percentage,
        isSortable: false,
        sortKey: "tags",
    },
    {
        labelPath: "policyPage.policy.violationRules.tableColumns.violations",
        propertyKey: "violations",
        colType: TableColumnTypeEnum.InternalNavigation,
        width: 12,
        widthType: WidthType.Percentage,
        isSortable: true,
        sortKey: "violations",
        internalNavigationQuery: "violationsEndpointQuery",
        internalNavigationRoute: "violationsEndpointRoute",
    },
    {
        labelPath: "policyPage.policy.violationRules.tableColumns.severity",
        propertyKey: "severity",
        colType: TableColumnTypeEnum.SeverityLabel,
        width: 12,
        widthType: WidthType.Percentage,
        isSortable: true,
        sortKey: "severity",
    },
    {
        labelPath: "policyPage.policy.violationRules.tableColumns.status",
        propertyKey: "statusLabel",
        colType: TableColumnTypeEnum.StatusLabel,
        width: 12,
        widthType: WidthType.Percentage,
        toCapitalize: true,
    },
    {
        labelPath: "",
        propertyKey: "modified",
        iconTableClass: "table-icon",
        tooltipIconText: "Default Rule Settings was Modified",
        colType: TableColumnTypeEnum.Modified,
        width: 2,
        widthType: WidthType.Percentage,
    },
];
